import React from 'react';
import createSVG from './createSVG';

const FavoritesIcon = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="1.71" d="M12.9878 25C-4.9498 14.1095.8142 1.1017 7.4203 1c1.986 0 4.0623 1.164 5.5675 4.0158C14.507 2.164 16.5843 1 18.5703 1h.0912c6.515.1018 12.279 13.1096-5.6737 24z"/>
);

export default createSVG(FavoritesIcon);
